import { css } from 'lit';

export const planeEventListStyles = css`
  :host {
    container-type: inline-size;
  }

  ol {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  .group {
    border: var(--border-width) solid var(--border);
    border-radius: var(--radius);
    background: var(--surface-raised);
  }

  .group + .group {
    margin-top: var(--space-5);
  }

  .group-head {
    display: flex;
    flex-wrap: wrap;
    gap: var(--space-2) var(--space-4);
    align-items: baseline;
    padding: var(--space-2) var(--space-4);
    border-bottom: var(--rule-width) solid var(--text);
    background: var(--surface);
    font-size: var(--font-size-ui);
  }

  .group-head .at {
    margin-left: auto;
    color: var(--text-muted);
    font-family: var(--font-mono);
    font-size: var(--font-size-xs);
  }

  .event {
    display: grid;
    position: relative;
    grid-template-columns: 10rem 6.5rem 1fr auto;
    gap: var(--space-3);
    align-items: center;
    padding: 0.5rem var(--space-4) 0.5rem calc(var(--space-4) + 1.25rem);
    font-size: var(--font-size-md);
  }

  /* A line of the network: one solid line down the apply, a stop on it at every phase, the
     latest filled in red (you are here). */
  .event::before {
    content: '';
    position: absolute;
    left: calc(var(--space-4) + 0.3rem - 2px);
    top: 0;
    bottom: 0;
    width: 4px;
    background: var(--text);
  }

  .event:first-child::before {
    top: 50%;
  }

  .event:last-child::before {
    bottom: 50%;
  }

  .event::after {
    content: '';
    position: absolute;
    left: calc(var(--space-4) + 0.3rem - 6px);
    top: calc(50% - 6px);
    width: 12px;
    height: 12px;
    border-radius: var(--radius-round);
    background: var(--surface-raised);
    border: 3px solid var(--text);
  }

  .event:first-child::after {
    background: var(--accent);
    border-color: var(--accent);
  }

  .event + .event {
    border-top: var(--border-width) solid var(--border);
  }

  .event .message {
    color: var(--text-muted);
    overflow-wrap: anywhere;
  }

  .event .at {
    color: var(--text-muted);
    font-family: var(--font-mono);
    font-size: var(--font-size-2xs);
    white-space: nowrap;
  }

  /* Narrow, as in the overview's side column: the message goes under the phase. */
  @container (max-width: 36rem) {
    .event {
      grid-template-columns: 1fr auto auto;
      row-gap: 0;
    }

    .event .message {
      grid-row: 2;
      grid-column: 1 / -1;
      font-size: var(--font-size-sm);
    }

    .event .message:empty {
      display: none;
    }
  }
`;
